module.exports = __webpack_public_path__ + "static/media/refresh.b832bb0d.svg";